import Tag from '/react4xp/components/prototype/Tag'

import type { ArticleHeroProps } from './types'

export default function ArticleHero({
	title,
	intro,
	tags = [],
	image,
	variant = 'default',
}: ArticleHeroProps) {
	return (
		<section className="bg-black-950 py-12">
			<div className="container grid grid-cols-1 gap-6 lg:gap-8 lg:grid-cols-2">
				<div className="flex flex-col gap-8">
					{title && <h1 className="h1 text-pure-white">{title}</h1>}

					{intro && <p className="body-xl text-brand-200">{intro}</p>}

					{tags.length > 0 && (
						<div className="flex flex-wrap gap-4">
							{tags.map((tag, i) => (
								<Tag key={i} label={tag.label} href={tag.href} isExternal={tag.isExternal} />
							))}
						</div>
					)}
				</div>

				{image && (
					<figure
						className={`w-full max-w-full overflow-hidden rounded-xs ${variant === 'event' ? 'aspect-333/218' : 'aspect-4/3'}`}
					>
						<img src={image.src} alt={image.alt ?? ''} className="object-cover w-full h-full" />
					</figure>
				)}
			</div>
		</section>
	)
}
